// src/pages/History/RenaissanceReformation/NorthernRenaissanceGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Renaissance_&_Reformation_-_Northern_Renaissance.png';

export default function HistoryPageNorthernRenaissanceGo() {
  return (
    <QuizPage
      title="History: Northern Renaissance"
      subTopic="Northern Renaissance"
      backgroundImage={historyImage}
      returnPath="/History-Northern-Renaissance"
    />
  );
}
